module.exports = __webpack_public_path__ + "img/icon.cd3974da.png";